import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  DASHBOARD_URL,
  USER_REGISTRATION_URL,
  INDIVIDUAL,
  MOBILE_VERIFICATION_URL,
  CORPORATE,
  SG_ONBOARDING_CORPORATE_URL,
  UTM_CAMPAIGNING,
  CONSENT_PERMISSION_URL,
  EMAIL_VERIFICATION_URL,
  IN,
  NIUM_FOREX_URL,
  DEVICE_ID_COOKIE_NAME,
  CAPTCHA_TOKEN_ERROR,
  MY_INFO_RESGISTRATION_URL,
  SIGNUP_URL,
  INVITE_URL,
  FORGOT_PASSWORD_URL,
  SIGNIN_URL,
  CHANGE_PASSWORD_URL_START,
  IS_TURNSTILE_ENABLED,
  CAPTCHA_RECOVERY_POPUP_ENABLED,
  BASE_URL
} from '../../utils/constants';
import {
  expiresAfter,
  getUniqueSessionId,
  getUTMQuery,
  setCookie,
  deleteCookie,
  constructQueryParams,
  showIpScreen,
  generateRandomStringId,
  getCookie,
  isIframeWindow
} from '../../utils/library';
import { authenticateUser, logInRequest, newSignUpRequest } from '@Redux/actions/authentication';
import { activateLoader, disableLoader } from '@Redux/actions/ui-trigger';
import { showMessage } from '@Redux/actions/common-message';
import { storeNiumForexUser } from '@Redux/actions/nium-forex';
import './authentication.scss';
import { getInstapointsLogic } from '@Redux/actions/user-state';
import NewAuthScreen from './sign-up/NewAuthScreen';
import { getInstaPoints } from '@Redux/actions/instapoints';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { CLOSE_NEW_ICON, INSTAREM_LOGO_ICON, NEW_INSTAREM_MONEY_SIMPLE_ICON } from '@Images';
import { logEvent } from '@Utils/events/logUserEvents';
import { EventNames, FLOW_TYPE, LOG_TYPE } from '@Utils/events/eventsConstants';
import { SIGNUP } from '@Utils/constants/eventsConstants';
import withRouterV6 from '../../components/common/withRouterV6';
import { renderTurnstileWidget } from '../../utils/turnstile';
import { isFlagEnabled } from '@Redux/actions/flagsmith';
import VerificationFailureRecoveryPopup from '../../components/verification-failure-recovery-popup/VerificationFailureRecoveryPopup';

function onCloseHandler(pathname, navigate) {
  return () => {
    if (!/signup|signin|resetPassword|invite/gi.test(pathname)) return navigate(-1);
    return (window.location = '/');
  };
}

class Authentication extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      confirmPass: '',
      showerror: false,
      otp: '',
      otp_text: false,
      isSignUp: false,
      deviceId: null,
      captchaToken: '',
      shouldShowCaptcha: false,
      showVerificationFailurePopup: false,
      loggingIssueContent: null
    };
    this.redirectLink = USER_REGISTRATION_URL;
    this.turnstileWidgetId = null;
    this.turnstileCallback = null;
  }

  updateFromChild = async (propertyName, event) => {
    await this.setState({ [propertyName]: event.target.value });
    this.forceUpdate();
  };

  UNSAFE_componentWillMount = () => {
    this.props.activateLoader();
    this.initializeFingerprint();
    const {
      location,
      location: { search }
    } = this.props;
    const params = new URLSearchParams(search);
    const redirectUrl = params.get('redirectUrl');
    if (redirectUrl) {
      const absolute = redirectUrl.startsWith('/') ? redirectUrl : `/${redirectUrl}`;
      this.redirectLink = absolute.startsWith(BASE_URL) ? absolute : `${BASE_URL}${absolute}`;
    }
    if (location && search) {
      const utmData = getUTMQuery(search);
      const { clickref } = constructQueryParams(search);
      if (utmData) {
        setCookie('utm', JSON.stringify(utmData), expiresAfter(30));
        setCookie(UTM_CAMPAIGNING, JSON.stringify(utmData), expiresAfter(30));
      }
      if (clickref) setCookie('clickref', clickref, expiresAfter(30));
    } else {
      deleteCookie(UTM_CAMPAIGNING);
    }
  };

  generateManualDeviceId = () => {
    let deviceId = getCookie(DEVICE_ID_COOKIE_NAME);
    if (!deviceId) {
      deviceId = generateRandomStringId(32);
    }
    // make the cookie invalid after 24 hours
    setCookie(DEVICE_ID_COOKIE_NAME, deviceId, expiresAfter(1));
    this.setState({ deviceId });
  };

  initializeFingerprint = async () => {
    try {
      const fpPromise = FingerprintJS.load({
        monitoring: false // Set to true if using pro version
      });
      const fp = await fpPromise;
      const result = await fp.get();

      if (!result?.visitorId) {
        this.generateManualDeviceId();
      } else {
        // make the cookie invalid after 24 hours
        setCookie(DEVICE_ID_COOKIE_NAME, result?.visitorId, expiresAfter(1));
        this.setState({ deviceId: result?.visitorId });
      }
    } catch (err) {
      this.generateManualDeviceId();
      const ctData = {
        pageName: SIGNUP,
        message: 'Fingerprint deviceId Generation Failed',
        err
      };
      logEvent(EventNames.Error, FLOW_TYPE.SIGNUP, ctData, LOG_TYPE.CLEVER_TAP);
      //eslint-disable-next-line
      console.error('Fingerprinting error:', err);
    }
  };

  componentDidMount = () => {
    this.props.disableLoader();
  };

  formUnmount = () => {
    this.setState({ showerror: false });
  };

  // Called for client-side captcha failures (no server response available)
  showClientCaptchaError = () => {
    this.props.disableLoader();
    this.props.showMessage({ text: [CAPTCHA_TOKEN_ERROR], type: 'info' });
  };

  // Called with the server response; shows recovery popup on 421
  showServerCaptchaError = (response) => {
    this.props.disableLoader();
    const statusCode = response?.status;

    if (isFlagEnabled(CAPTCHA_RECOVERY_POPUP_ENABLED) && statusCode === 421) {
      this.setState({ showVerificationFailurePopup: true });
    }
  };

  getTurnstileToken = () => {
    return new Promise((resolve, reject) => {
      const container = document.getElementById('turnstile-widget-container');
      if (!container || !window.turnstile) {
        resolve(null);
        return;
      }
      this.turnstileCallback = resolve;
      if (this.turnstileWidgetId === null) {
        this.turnstileWidgetId = renderTurnstileWidget(container, {
          onSuccess: (token) => {
            if (this.turnstileCallback) this.turnstileCallback(token);
          },
          onError: () => reject(new Error('Turnstile challenge failed'))
        });
        if (this.turnstileWidgetId === null) {
          resolve(null);
          return;
        }
      } else {
        window.turnstile.reset(this.turnstileWidgetId);
      }
      window.turnstile.execute(this.turnstileWidgetId);
    });
  };

  newSubmit = async (params) => {
    const urlParams = new URLSearchParams(this.props.location?.search || '');
    const deepLinkValue = urlParams.get('deep_link_value');
    const props = { ...params };
    if (deepLinkValue) props.signup_source = deepLinkValue;
    const partnerCode = urlParams.get('partner');
    const partnerLinkToken = urlParams.get('code');
    if (partnerCode) props.partner_code = partnerCode.toUpperCase();
    if (partnerLinkToken) props.partner_link_token = partnerLinkToken;
    this.props.activateLoader();
    const { grecaptcha } = window;
    if (!grecaptcha) {
      this.showClientCaptchaError();
      return;
    }
    let token;
    const isTurnStileEnabled = isFlagEnabled(IS_TURNSTILE_ENABLED);
    if (!this.state.shouldShowCaptcha) {
      try {
        await new Promise((resolve) => grecaptcha.enterprise.ready(resolve));
        token = await window.grecaptcha.enterprise.execute(
          import.meta.env.VITE_ENTERPRISE_CAPTCHA_KEY_V3,
          {
            action: 'signup'
          }
        );
      } catch (error) {
        this.showClientCaptchaError();
        return;
      }
    }
    let version = 'v3';
    let captchaToken = token,
      turnstileToken;
    if (this.state.shouldShowCaptcha) {
      version = 'v2';
      captchaToken = this.state.captchaToken;
    }
    if (!captchaToken) {
      this.showClientCaptchaError();
      return;
    }
    if (isTurnStileEnabled && !this.state.shouldShowCaptcha) {
      try {
        turnstileToken = await this.getTurnstileToken();
        if (!turnstileToken) {
          this.showClientCaptchaError();
          return;
        }
      } catch (error) {
        this.showClientCaptchaError();
        return;
      }
    }

    if (isTurnStileEnabled && !this.state.shouldShowCaptcha)
      props.token = `${turnstileToken}:${captchaToken}`;
    else props.captchaToken = `${version}:${captchaToken}`;

    const response = await this.props.newSignUpRequest(
      { ...props, device_id: this.state.deviceId },
      {
        formID: 'form-sign-up'
      }
    );

    if ((partnerCode || partnerLinkToken) && response?.status === 400) {
      this.props.disableLoader();
      this.props.showMessage({
        text: [response?.data?.data?.message],
        type: 'info'
      });
      return;
    }

    if (response?.data?.data) {
      const { emailVerificationRequired = false } = response.data.data;
      if (emailVerificationRequired)
        this.props.navigate(EMAIL_VERIFICATION_URL, {
          state: {
            emailVerificationData: {
              ...response.data.data,
              email: props.email,
              utmCampaigningCookie: response.utmCampaigningCookie,
              referred_by_referral_code: props.referred_by_referral_code,
              is_term_conditions_accepted: props.is_term_conditions_accepted,
              auth_type: 'BASIC',
              deepLinkValue,
              device_id: this.state.deviceId
            }
          }
        });
      else if (response.data.success && response.data.data.show_captcha_prompt) {
        this.props.disableLoader();
        this.setState({ shouldShowCaptcha: true });
      } else if (response.data.success && response.data.data.user) {
        const { user } = response.data.data;
        this.setState({ showerror: false });
        const { country_code } = user;
        const { referred_by_referral_code } = props;

        const ips = await this.props.getInstapointsLogic();
        const isSGCorporate = ['SG'].includes(user.country_code) && user.account_type === CORPORATE;
        let redirectLink =
          country_code === 'SG' ? MY_INFO_RESGISTRATION_URL : USER_REGISTRATION_URL;
        if (
          props.account_type === INDIVIDUAL &&
          props.country_code !== 'MY' &&
          !isIframeWindow() &&
          ips.welcome_instapoint > 0
        ) {
          const instapointsResponse = await this.props.getInstaPoints();
          redirectLink = await showIpScreen(
            country_code,
            user.account_type,
            instapointsResponse,
            referred_by_referral_code
          );
          if (country_code === IN) {
            redirectLink = NIUM_FOREX_URL;
            this.props.storeNiumForexUser(true);
          }
        }
        await this.props.authenticateUser(false, 'sign-up', false, props.referred_by_referral_code);
        this.props.disableLoader();
        if (isSGCorporate) {
          window.location.href = `${SG_ONBOARDING_CORPORATE_URL}?remitterID=${user.remitter_id}&countryCode=${user.country_code}`;
        }
        return this.props.navigate(redirectLink);
      } else {
        this.showServerCaptchaError(response);
      }
    }
  };

  // catch unhandled
  submitSignIn = async ({ email, password }) => {
    if (this.props.is_user_authenticated) {
      this.props.navigate(this.redirectLink);
      return;
    }
    this.props.activateLoader();
    const response = await this.props.logInRequest({
      email: email,
      password: password,
      session_id: getUniqueSessionId()
    });
    this.props.disableLoader();
    if (response && response.data && response.data.data) {
      const responseData = response.data.data;
      if (response.data.success) {
        if (responseData?.is_internal === false && !responseData?.partner_permission_granted) {
          //For Partner user
          let state = {
            countryCode: responseData.countryCode,
            isConsentForm: true,
            authorizePartnerToken: responseData.authorizePartnerToken
          };
          if (response.data.data.twoFA) {
            const { twoFA, twoFAToken, accountType } = response.data.data;
            state = { ...state, twoFA, twoFAToken, accountType };
          }
          this.props.navigate(CONSENT_PERMISSION_URL, { state });
        } else if (response.data.data.twoFA) {
          const { twoFA, twoFAToken, accountType } = response.data.data;
          this.props.navigate(MOBILE_VERIFICATION_URL, {
            state: { twoFA, twoFAToken, accountType }
          });
        } else if (this.redirectLink !== USER_REGISTRATION_URL) {
          this.props.navigate(this.redirectLink);
        }
        // already being called in logInRequest
        else {
          this.props.navigate(DASHBOARD_URL);
        }
      }
    }
  };

  handleLoggingContentFetched = (content) => this.setState({ loggingIssueContent: content });

  getScreenProps = () => {
    const { params, location, navigate } = this.props;
    const pathname = location.pathname;
    const baseProps = {
      navigate,
      params,
      location,
      formUnmount: this.formUnmount,
      handlerFromParent: this.updateFromChild
    };

    if (pathname === SIGNUP_URL) {
      return {
        ...baseProps,
        captchaHandler: (value) => this.setState({ captchaToken: value }),
        shouldShowCaptcha: this.state.shouldShowCaptcha,
        submitHandler: this.newSubmit,
        isSignUp: () => this.setState({ isSignUp: true })
      };
    }

    if (pathname.startsWith(INVITE_URL)) {
      return {
        ...baseProps,
        captchaHandler: (value) => this.setState({ captchaToken: value }),
        shouldShowCaptcha: this.state.shouldShowCaptcha,
        submitHandler: this.newSubmit,
        isSignUp: () => this.setState({ isSignUp: true })
      };
    }

    if (pathname === FORGOT_PASSWORD_URL) {
      return {
        ...baseProps,
        submitHandler: this.newSubmit,
        isSignUp: () => this.setState({ isSignUp: false })
      };
    }

    if (pathname === SIGNIN_URL) {
      return {
        ...baseProps,
        submitHandler: this.submitSignIn,
        isSignUp: () => this.setState({ isSignUp: false })
      };
    }

    if (pathname.startsWith(CHANGE_PASSWORD_URL_START)) {
      return {
        ...baseProps,
        isSignUp: () => this.setState({ isSignUp: false })
      };
    }

    return baseProps;
  };

  render() {
    const { location, navigate } = this.props;
    return (
      <div className="auth_container">
        {!isIframeWindow() && (
          <>
            <div className="auth_container_logo">
              {window.innerWidth < 500 ? (
                <img src={INSTAREM_LOGO_ICON} alt="instarem-logo" />
              ) : (
                <img src={NEW_INSTAREM_MONEY_SIMPLE_ICON} alt="instarem-logo" />
              )}
            </div>
            <img
              onClick={onCloseHandler(location.pathname, navigate)}
              className="auth_container_close"
              src={CLOSE_NEW_ICON}
              alt="close"
            />
          </>
        )}
        <div id="turnstile-widget-container" className="turnstile-hidden" />
        {/* Render NewAuthScreen with appropriate props based on route */}
        <NewAuthScreen
          {...this.getScreenProps()}
          onLoggingContentFetched={this.handleLoggingContentFetched}
        />
        <VerificationFailureRecoveryPopup
          open={this.state.showVerificationFailurePopup}
          onClose={() => this.setState({ showVerificationFailurePopup: false })}
          navigate={navigate}
          loggingIssueContent={this.state.loggingIssueContent}
        />
      </div>
    );
  }
}

Authentication.propTypes = {
  getInstaPoints: PropTypes.func,
  params: PropTypes.object,
  location: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
  logInRequest: PropTypes.func,
  newSignUpRequest: PropTypes.func,
  authenticateUser: PropTypes.func,
  is_user_authenticated: PropTypes.bool,
  activateLoader: PropTypes.func,
  disableLoader: PropTypes.func,
  user_session: PropTypes.object,
  showMessage: PropTypes.func,
  getInstapointsLogic: PropTypes.any,
  storeNiumForexUser: PropTypes.func,
  device: PropTypes.string
};

function mapStateToProps(state) {
  const {
    rootReducer: {
      userSessionReducer: { is_user_authenticated }
    }
  } = state;
  return {
    is_user_authenticated
  };
}

export default withRouterV6(
  connect(mapStateToProps, {
    logInRequest,
    newSignUpRequest,
    authenticateUser,
    activateLoader,
    disableLoader,
    showMessage,
    getInstapointsLogic,
    getInstaPoints,
    storeNiumForexUser
  })(Authentication)
);
